import $ from 'jquery';

$(document).on('ready turbo:load turbo:frame-load', function () {
  $('.hero-slideOut').each(function (i, slideOut) {
    if (slideOut.scrollHeight > slideOut.clientHeight) {
      $(slideOut)
        .parent()
        .find('.hero-slideOutArrow')
        .addClass('hero-slideOutArrow--visible');
    }
  });
});

$(document).on('change', '#hero_details', function () {
  $(this)
    .parents('#hero')
    .find('.hero-background')
    .toggleClass('hero-background--dark', $(this).is(':checked'));
});
